import * as Sentry from '@sentry/browser';

const WIDGET_SCRIPT_URL = 'https://app.purechat.com/VisitorWidget/WidgetScript';
const WIDGET_CLIENT_ID = '0a7b5ef9-ca8b-47cc-8564-7bcd7e7e641a';
const READY_TIMEOUT_MS = 15000;

let currentScriptEl = null;
let readyTimeoutId = null;

function freshPurechatApiStub() {
    return {
        l: [],
        t: [],
        on: function () {
            this.l.push(arguments);
        },
    };
}

function markUnavailable(reason) {
    clearTimeout(readyTimeoutId);
    window.isPurechatReady = false;
    window.isPurechatUnavailable = true;
    Sentry.captureMessage(`Purechat widget unavailable: ${reason}`, { level: 'warning' });
    window.dispatchEvent(new CustomEvent('purechat:unavailable'));
}

function markReady() {
    clearTimeout(readyTimeoutId);
    window.isPurechatReady = true;
    window.isPurechatUnavailable = false;
    window.dispatchEvent(new CustomEvent('purechat:ready'));
}

// Claude (Rec0BUU16TDU0): the widget's loader script replaces window.purechatApi
// wholesale and replays whatever `.l`/`.t` queues it finds on the stub it's handed
// (confirmed by inspecting the loaded WidgetScript payload), so re-bootstrapping is
// just a matter of swapping in a fresh stub and loading the script again. This runs
// again on every `livewire:navigated`: wire:navigate's document.body.replaceWith()
// destroys whatever DOM the widget injected into <body>, and although Livewire
// clones and reinserts this file's own <script type="module"> tag on every
// navigation, ES module specifier caching means its top-level body only ever runs
// once per document — nothing else rebuilds the widget after the first navigate.
function bootPurechatWidget() {
    clearTimeout(readyTimeoutId);
    window.isPurechatReady = false;
    window.isPurechatUnavailable = false;

    window.purechatApi = freshPurechatApiStub();
    window.purechatApi.on('chatbox:ready', markReady);

    if (currentScriptEl) {
        currentScriptEl.remove();
        currentScriptEl = null;
    }

    let settled = false;
    const script = document.createElement('script');
    script.async = true;
    script.type = 'text/javascript';
    script.src = WIDGET_SCRIPT_URL;

    script.onerror = function () {
        if (settled) {
            return;
        }

        settled = true;
        markUnavailable('widget script failed to load');
    };

    script.onreadystatechange = script.onload = function () {
        if (settled || (this.readyState && this.readyState !== 'loaded' && this.readyState !== 'complete')) {
            return;
        }

        settled = true;

        try {
            new PCWidget({ c: WIDGET_CLIENT_ID, f: true });
        } catch (e) {
            Sentry.captureException(e);
            markUnavailable('widget failed to initialize');
        }
    };

    document.getElementsByTagName('HEAD').item(0).appendChild(script);
    currentScriptEl = script;

    readyTimeoutId = setTimeout(() => {
        if (!window.isPurechatReady) {
            markUnavailable('timed out waiting for chatbox:ready');
        }
    }, READY_TIMEOUT_MS);
}

bootPurechatWidget();

document.addEventListener('livewire:navigated', bootPurechatWidget);
